import { Icone, type PropsDeIcone } from './IconesDeNavegacao'

/**
 * Os ícones dos documentos do contrato e da consulta a eles.
 *
 * Arquivo próprio porque `Icones.tsx` já encosta no teto de 200 linhas; a moldura é a mesma
 * (`Icone`), e a dependência segue o sentido único: daqui para `IconesDeNavegacao`, nunca o contrário.
 */

/** Documento com texto: a folha com a dobra e as linhas. */
export function IconeDocumento(props: PropsDeIcone) {
  return (
    <Icone {...props}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </Icone>
  )
}

/** Conversa: o balão com a interrogação — perguntar ao contrato. */
export function IconeConversa(props: PropsDeIcone) {
  return (
    <Icone {...props}>
      <path d="M20 12a8 8 0 0 1-11.6 7.1L4 20l1-4.1A8 8 0 1 1 20 12Z" />
      <path d="M10 9.6a2 2 0 1 1 2.7 1.9c-.4.2-.7.6-.7 1v.3M12 15.5h.01" />
    </Icone>
  )
}

/** Enviar: a seta para cima saindo da bandeja. */
export function IconeEnviar(props: PropsDeIcone) {
  return (
    <Icone {...props}>
      <path d="M12 15V4M7.5 8.5 12 4l4.5 4.5" />
      <path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
    </Icone>
  )
}

/** Página: a folha com o canto marcado — abrir o documento na página citada. */
export function IconePagina(props: PropsDeIcone) {
  return (
    <Icone {...props}>
      <path d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
      <path d="M15 3v6l-2-1.5L11 9V3" />
    </Icone>
  )
}
